import { connect } from 'react-redux';

export const withResizer = connect(state => ({ resizeData: state.resizeReducer }), null, null, { forwardRef: true });

export const withTranslations = connect(state => ({ translationsData: state.translationsReducer }), null, null, { forwardRef: true });

export const withUser = connect(state => ({ userData: state.userDetailsReducer }), null, null, { forwardRef: true });